import { apiInstance } from '@/api/api.js'
import axios from 'axios'

const api = apiInstance()
const CORRECT_STATUS = 200

export default {
  async getResources({ rootState, commit, dispatch }, { profileIds = [] }) {
    const receiverProfileIds = profileIds.length
      ? profileIds
      : [(rootState.userStates || {}).profileId]
    const url = `/ml/resources?receiverProfileIds=${receiverProfileIds.join(
      ',',
    )}`

    try {
      commit('setLoading', true)
      const response = await api.get(url)
      commit('setResources', response.data)
      commit(
        'headersStates/setHeadersEtag',
        { headers: response.headers, url },
        { root: true },
      )
      commit('setLoading', false)
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },
  async getResourceByUrl({ commit }, { resourceUrl = '' }) {
    try {
      const response = await api.get(resourceUrl)
      return response
    } catch (error) {
      return error
    }
  },
  async getResourceById({ commit }, { resourceId = '' }) {
    const url = `/ml/resources/${resourceId}`
    try {
      const response = await api.get(url)
      return response
    } catch (error) {
      return error
    }
  },
  async getResource({ state, commit, dispatch, rootState }, { id }) {
    const url = `/ml/resources/${id}`
    try {
      const { headersStates } = rootState

      commit('setLoading', true)
      const response = await api.get(url)
      commit(
        'headersStates/setHeadersEtag',
        { headers: response.headers, url },
        { root: true },
      )
      commit('setResource', response.data)
      commit('setLoading', false)
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },
  async searchResources({ rootState, commit, dispatch }, { params }) {
    const url = `/ml/resources/search`

    try {
      const { headersStates } = rootState
      commit('setLoading', true)
      const response = await api.get(url, { params })
      commit('setResources', response.data)
      commit('setLoading', false)
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },
  async sendResource(
    { commit, dispatch },
    { storageFileId, receiversIds = [] },
  ) {
    try {
      commit('setLoading', true)
      const data = {
        storageFileId,
        compress: false,
        receiversId: receiversIds.join(','),
      }

      const response = await api.post(`/ml/resources/send`, data)
      return response
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },
  async downloadResourceByUrl({ commit, dispatch }, { resourceUrl }) {
    try {
      await api.get(resourceUrl).then(response => {
        if (response.data && response.data.fileUrl) {
          const { fileUrl, name } = response.data
          axios
            .get(fileUrl, {
              responseType: 'arraybuffer',
              headers: {
                'Cache-Control': 'no-cache, no-store, must-revalidate',
                Pragma: 'no-cache',
                Expires: '0',
              },
            })
            .then(response => {
              const url = window.URL.createObjectURL(new Blob([response.data]))
              const link = document.createElement('a')
              link.href = url
              link.setAttribute('download', name) //or any other extension
              document.body.appendChild(link)
              link.click()
            })
            .catch(error => {
              commit(
                'appStates/setSnackbarNotification',
                'Please try again! ' + error.message,
                { root: true },
              )
            })
        }
      })
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
    }
  },
  async sendExistingResource(
    { commit },
    { resourceId = null, receiversIds = [] },
  ) {
    try {
      const response = await api.post(`/ml/resources/${resourceId}/send`, {
        receiversId: receiversIds,
      })
      return response
    } catch (error) {
      return error
    }
  },
  async likeResource({ commit }, { resourceId = null, isFavorite = false }) {
    try {
      const response = await api.post(`/ml/resources/${resourceId}/like`, {
        isFavorite: isFavorite,
      })
      return response
    } catch (error) {
      return error
    }
  },
  async checkFileAvailable(
    { rootState, commit, dispatch },
    { url, dialogFileMlUrl, name, cb = false },
  ) {
    try {
      const { headersStates } = rootState
      axios
        .get(url, {
          responseType: 'arraybuffer',
          headers: {
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            Pragma: 'no-cache',
            Expires: '0',
          },
        })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          if (!name) name = response.name
          link.setAttribute('download', name) //or any other extension
          document.body.appendChild(link)
          link.click()
        })
        .catch(error => {
          if (cb) {
            cb(dialogFileMlUrl)
          } else {
            dispatch('appStates/setErrorMessage', error, { root: true })
          }
        })
    } catch (error) {
      if (cb) {
        cb(dialogFileMlUrl)
      } else {
        dispatch('appStates/setErrorMessage', error, { root: true })
      }
    }
  },
  async changeLockedFileTitle(
    { rootState, commit, dispatch },
    { directoryId, resourceId, title, version },
  ) {
    try {
      const { headersStates, libraryStates } = rootState
      commit('setLoading', true)
      let data = { title: title }
      await api.put(`/ml/resources/${resourceId}/title`, data, {
        headers: { 'If-Match': 'W/"' + version + '"' },
      })
      await dispatch(
        'libraryStates/getDirectory',
        {
          id: directoryId,
          pageSize: libraryStates?.directory?.pageMetadata?.pageSize,
          pageNumber: libraryStates?.directory?.pageMetadata?.pageNumber,
        },
        { root: true },
      )
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', 'Title changed!', {
        root: true,
      })
    } catch (error) {
      dispatch(
        'appStates/setErrorMessage',
        { ...error, withoutRetry: true },
        { root: true },
      )
      commit('setLoading', false)
    }
  },
  async shareResource(
    { rootState, commit, dispatch },
    { resourceId, companyId },
  ) {
    const url = `/ml/resources/${resourceId}/shareToCompany`
    try {
      commit('setLoading', true)
      const response = await api.post(url, {
        companyId: companyId,
      })
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', 'Shared!', { root: true })
    } catch (error) {
      commit('setLoading', false)
      dispatch('appStates/setErrorMessage', error, { root: true })
    }
  },
  async changeResourceThumbnail(
    { rootState, commit, dispatch },
    { resourceId, storageFileId },
  ) {
    const url = `/ml/resources/${resourceId}/thumbnail`
    try {
      commit('setLoading', true)
      const data = {
        storageFileId,
      }
      const response = await api.put(url, data)
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', 'Thumbnail changed!', {
        root: true,
      })
    } catch (error) {
      commit('setLoading', false)
      dispatch('appStates/setErrorMessage', error, { root: true })
    }
  },
  async changeResourceThumbnailMl(
    { rootState, commit, dispatch },
    { resourceId, version, mlFileId = null, staticMediaId = null },
  ) {
    const url = `/ml/resources/${resourceId}/thumbnail-ml`
    const data = {}
    if (mlFileId !== null) {
      data.resourceId = mlFileId
    }
    if (staticMediaId !== null) {
      data.staticMediaId = staticMediaId
    }
    if (mlFileId === null && staticMediaId === null) {
      return
    }
    try {
      commit('setLoading', true)
      const response = await api.put(url, data, {
        headers: {
          'If-Match': 'W/"' + version + '"',
        },
      })
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', 'Thumbnail changed!', {
        root: true,
      })
    } catch (error) {
      commit('setLoading', false)
      dispatch('appStates/setErrorMessage', error, { root: true })
    }
  },
}
